// @flow strict

import React from 'react';

import * as styles from './page-intro.module.less';

type PageIntroProps = {
  headline: string,
  text: string,
};

export const PageIntro = ({ headline, text }: PageIntroProps) => {
  return (
    <div className={styles.pageIntro}>
      <h1 className={styles.pageIntro__headline}>{headline}</h1>
      <p className={styles.pageIntro__text}>{text}</p>
    </div>
  );
};
